import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { conf } from '../confg';
import './TopSiteBanner.css';

/**
 * بنر متنی بالای سایت — از GET /api/top-banner (تنظیمات پنل ادمین)
 */
const TopSiteBanner = () => {
  const [banner, setBanner] = useState(null);

  useEffect(() => {
    let cancelled = false;
    axios({ url: `${conf.server_url}top-banner`, method: 'GET' })
      .then((res) => {
        if (cancelled) return;
        const data = res?.data?.data;
        if (data?.enabled && data?.text) {
          setBanner(data);
        }
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);

  if (!banner) return null;

  const bg = banner.bg_color || '#01494b';
  const href = (banner.link || '').trim();
  const buttonText = (banner.button_text || '').trim();

  const inner = (
    <div className='top-site-banner__inner'>
      <span className='top-site-banner__text'>{banner.text}</span>
      {buttonText ? <span className='top-site-banner__btn'>{buttonText}</span> : null}
    </div>
  );

  return (
    <div className='top-site-banner' style={{ backgroundColor: bg }} role='region' aria-label='بنر سایت'>
      {href ? (
        <a className='top-site-banner__link' href={href} target={/^https?:\/\//i.test(href) ? '_blank' : undefined} rel='noopener noreferrer'>
          {inner}
        </a>
      ) : (
        inner
      )}
    </div>
  );
};

export default TopSiteBanner;
